'use strict';

exports.email = require('./email');
exports.noNumbers = require('./no-numbers');
exports.noNumbers = require('./phone-number');
exports.maxPhNumberLength = require('./phone-number-length.js');
exports.passwordPattern = require('./password-pattern');
exports.noDuplicate = require('./no-duplicate');
exports.customValidationError = require('./custom-validation-error');



// WEBPACK FOOTER //
// ./assets/js/validators/index.js